"use client";
import Link from "next/link";
import { usePathname } from "next/navigation";
import React from "react";
import ArrowLeftIcon from "@/components/_icons/arrowLeftIcon";

export const ProtectedHeader = () => {
  let backButtonText = "";
  let backLink = "";
  const pathname = usePathname();

  switch (pathname) {
    case "/my-appointments": {
      backButtonText = "My orders";
      backLink = "/services/all";
      break;
    }
    case "/my-orders": {
      backButtonText = "My orders";
      backLink = "/";
      break;
    }
    default: {
      backButtonText = "Back";
      backLink = "/";
      break;
    }
  }

  return (
    <div
      className={[
        "flex",
        "flex-col",
        "items-center",
        "relative",
        "sm:sticky",
        "top-0",
        "z-20",
        "bg-white",
        "shadow-md",
      ].join(" ")}
    >
      <div
        className={[
          "flex",
          "flex-row",
          "px-10",
          "py-8",
          "w-full",
          "justify-between",
        ].join(" ")}
      >
        <Link href={backLink}>
          <div
            className={["flex", "flex-row", "gap-3", "items-center"].join(" ")}
          >
            <ArrowLeftIcon />

            <p className="text-[20px] font-medium text-[#373737]">
              {backButtonText}
            </p>
          </div>
        </Link>
      </div>
    </div>
  );
};
